import styled, { css, keyframes } from 'styled-components'

const pulseBeacon = keyframes`
  0% {
    stroke-width: 5px;
    stroke-opacity: 1;
    transform: scale(0.3);
  }

  100% {
    stroke-width: 0;
    stroke-opacity: 0;
    transform: scale(2);
  }
`

export const CircleSVG = styled.svg(
  ({ size }) => css`
    flex-basis: ${size}em;
    flex-shrink: 0;
    height: ${size}em;
    margin: 10px;
  `
)

export const Circle = styled.circle(
  ({ color }) => css`
    stroke-width: 2px;
    stroke-opacity: 1;
    fill: ${color};
    stroke: ${color};
  `
)

export const PulseBeacon = styled.circle(
  ({ color }) => css`
    overflow: visible;
    stroke: ${color};
    stroke-width: 2px;
    stroke-opacity: 1;
    fill: white;
    fill-opacity: 0;
    transform-origin: 50% 50%;
    animation: ${pulseBeacon} 2s linear;
    animation-iteration-count: infinite;
  `
)



// WEBPACK FOOTER //
// ./src/components/PulsatingCircle/index.style.js